import axios from 'axios'
import persist from './persist'

export default {
    state: {

        invite: {
            customer_email: '',
            address_string: '',
            available_am: false,
            available_pm: false,
            bool_avail_am: false,
            bool_avail_pm: false,
            appt_id: 0,
        },
        appointment: {
            customer_email: '',
            address_string: '',
            available_am: false,
            available_pm: false,
            bool_avail_am: false,
            bool_avail_pm: false,
        },
        inviteVerified: false,
        appointmentSelected: false,
        appointmentDurationOptions: [
            { value: 0, label: '0m' },
            { value: '900', label: '15m' },
            { value: '1800', label: '30m' },
            { value: '2700', label: '45m' },
            { value: '3600', label: '1h00' },
            { value: '4500', label: '1h15m' },
            { value: '5400', label: '1h30m' },
            { value: '6300', label: '1h45m' },
            { value: '7200', label: '2h00m' },
            { value: '10800', label: '3h00m' },
        ],
        appointmentTypeOptions: [
            { value: 'survey', label: 'Survey' },
            { value: 'advanced_survey', label: 'Advanced Survey' },
            { value: 'standard', label: 'Standard Install' },
            { value: 'advanced', label: 'Advanced' },
            { value: 'maintenance', label: 'Maintenance' },
            { value: 'advanced_maintenance', label: 'Advanced Maintenance' },
            { value: 'upgrade', label: 'Upgrade' },
            { value: 'wifi_expert', label: 'WiFi Expert' },
        ],
        appointmentVehicleOptions: [
            { value: '1', label: 'Bucket Required' },
            { value: '2', label: 'Bucket Preferred' },
            { value: '3', label: 'Any' },
        ],
        appointmentOptions: [],
        appointmentVerification: {

        },
    },
    mutations: {
        SAVE_APPT (state, data) {
            state.appointment = data
        },
        SAVE_INVITE (state, data) {
            state.invite = data
        },
        GET_APPOINTMENT (state, data) {
            state.appointment = data
        },
        GET_APPOINTMENT_OPTIONS (state, data) {
            state.appointmentOptions = data
        },
        VERIFY_APPOINTMENT (state, data) {
            state.inviteVerified = data
        },
    },
    actions: {
        async getInvite ({ dispatch, commit, rootState, state }, payload) {
            // console.log(rootState);
            // console.log(payload);
            const headers = {
                // 'Authorization': 'Bearer ' + rootState.auth.authToken,
            }
            try {
                const { data } = await axios({
                    method: 'get',
                    url: rootState.serverURL + '/api/v1/entrance/invites/' + payload.invite + '?secret=' + payload.secret,
                    headers,
                    timeout: 3000,
                })
                console.log(data)
                if (data.appt_id > 0) {
                    var newpayload = { invite: payload.invite, appt_id: data.appt_id }
                    dispatch('getAppointment', newpayload)
                }
                console.log(data)
                state.invite = data

              // commit('SAVE_INVITE', data)
            } catch (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('ERROR IN RESPONSE')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('ERROR IN REQ')

                    console.log(error.request)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message)
                }
                console.log('ERROR CONFIG:')

                console.log(error.config)
            }
        },
        async getAppointment ({ dispatch, commit, rootState, state }, payload) {
            // console.log(rootState);
            // console.log(payload);
            const headers = {
                // 'Authorization': 'Bearer ' + rootState.auth.authToken,
            }
            try {
                const { data } = await axios({
                    method: 'get',
                    url: rootState.serverURL + '/api/v1/entrance/appointments/' + payload.appt_id + '?invite=' + payload.invite,
                    headers,
                    timeout: 3000,
                })
                console.log(data)
                state.appointment = data

              // commit('SAVE_APPT', data)
            } catch (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('ERROR IN RESPONSE')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('ERROR IN REQ')

                    console.log(error.request)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message)
                }
                console.log('ERROR CONFIG:')

                console.log(error.config)
            }
        },
        async getAppointmentOptions ({ dispatch, commit, rootState, state }, payload) {
            // console.log(rootState);
            // console.log(payload);
            const headers = {
                // 'Authorization': 'Bearer ' + rootState.auth.authToken,
            }
            try {
              const { data } = await axios({ method: 'get', url: rootState.serverURL + '/api/v1/entrance/appointments/' + payload.invite + '/options' + '?secret=' + payload.secret, headers, timeout: 15000 })
              console.log(data)
              // commit('GET_APPOINTMENT_OPTIONS', data)
              state.appointmentOptions = data
              return data
            } catch (error) {
              if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('ERROR IN RESPONSE')
                  console.log(error.response.data)
                  console.log(error.response.status)
                  console.log(error.response.headers)
              } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('ERROR IN REQ')

                  console.log(error.request)
              } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message)
              }
              console.log('ERROR CONFIG:')

              console.log(error.config)
              throw error
            }
        },
        async verifyInvite ({ dispatch, commit, rootState, state }, payload) {
            // console.log(rootState);

            try {
              const { data } = await axios({ method: 'post', url: rootState.serverURL + '/api/v1/entrance/invites/verify', data: payload, headers: {}, timeout: 30000 })
              console.log('verified the invite')
              console.log(data)
              state.inviteVerified = true

              // commit('VERIFY_APPOINTMENT', data)
              this.dispatch('getAppointmentOptions', payload)
              return true
            } catch (error) {
              state.inviteVerified = false

              if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('ERROR IN RESPONSE')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('ERROR IN REQ')

                    console.log(error.request)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message)
                }
                console.log('ERROR CONFIG:')

                console.log(error.config)
                return false
            }
        },
        async acceptAppointmentOption ({ dispatch, commit, rootState }, payload) {
            // console.log(rootState);

            try {
                const { data } = await axios({ method: 'post', url: rootState.serverURL + '/api/v1/entrance/appointments/accept-appt-option', data: payload, headers: {}, timeout: 3000 })
                console.log(data)
                return data
                // commit('VERIFY_APPOINTMENT', data);
                // this.dispatch('getAppointmentOptions', payload);
                // return true;
            } catch (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('ERROR IN RESPONSE')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('ERROR IN REQ')

                    console.log(error.request)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message)
                }
                console.log('ERROR CONFIG:')

                console.log(error.config)
                return false
            }
        },
    },
    getters: {
        inviteRecord: state => state.invite,
        appointmentRecord: state => state.appointment,
        appointmentTypeOptions: state => state.appointmentTypeOptions,
        appointmentDurationOptions: state => state.appointmentDurationOptions,
        appointmentOptions: state => state.appointmentOptions,
        inviteVerified: state => state.inviteVerified,
        appointmentSelected: state => state.appointmentSelected,
    },
    plugins: [persist.plugin],
}
